import React from 'react'
import {Drawer, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {toTitleCase} from "../../../../helpers/utils";
import {ChipLabel} from "../../shared/Chips";

const TasksQueueSidebar = ({
                               queuedTasks,
                               goToSpecificTask,
                           }) => {

    const completedTasksAmount = queuedTasks.filter(e => e.status === 'finished')?.length
    const skippedTasksAmount = queuedTasks.filter(e => e.status === 'skipped')?.length

    const renderStatusChip = (status) => {
        status = status ? status : 'incomplete'
        const colors = {
            skipped: 'red',
            finished: 'green',
            current: 'orange',
            incomplete: 'grey'
        }
        return (
            <ChipLabel className={'status-chip'} label={toTitleCase(status)}
                       style={{backgroundColor: `${colors[status]}`, color: '#FFFFFF'}}/>
        )
    }

    const isClickable = (task) => {
        return !task.active && (task.status === 'skipped' || task.status === 'finished' || task.status === 'current')
    }

    const goToTask = (task) => {
        if (isClickable(task)) {
            goToSpecificTask(task)
        }
    }

    return (
        <React.Fragment>
            <div className='tasks-queue-sidebar'>
                <div className='tasks-queue-sidebar__table-container'>
                    <p style={{textAlign: 'center'}}>TASKS QUEUE</p>
                    <TableContainer className='tasks-queue-sidebar__table-container__table'>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {queuedTasks.map((row) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                        className={row.active ? 'current-task' : ''}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.task_type === 'Other' && !!row.task_description ? row.task_description : row.task_type}
                                        </TableCell>
                                        <TableCell className={isClickable(row) ? 'blue-hover' : ''}
                                                   onClick={() => goToTask(row)}>{toTitleCase(row.item_name)}</TableCell>
                                        <TableCell>{renderStatusChip(row.status)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-around'}}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid',
                        padding: '5px'
                    }}>
                        <p>Skipped Tasks</p>
                        <ChipLabel className={'status-chip'} label={skippedTasksAmount}
                                   style={{backgroundColor: 'red', color: '#FFFFFF'}}/>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid',
                        padding: '5px'
                    }}>
                        <p>Completed Tasks</p>
                        <ChipLabel className={'status-chip'} label={completedTasksAmount}
                                   style={{backgroundColor: 'green', color: '#FFFFFF'}}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default TasksQueueSidebar